import { useRef, useState } from "react";
import MarketResearchList from "../MarketResearch/MarketResearchList";
import AddButton from "../../components/UIElements/AddButton";
import AddMarketResearch from "../MarketResearch/AddMarketResearch";
import AddMarketNewRelease from "../MarketNewRelease/AddMarketNewRelease";
import MarketNewResearchList from "../MarketNewRelease/MarketNewResearchList";
import VideoList from "../video/VideoList";
import AddVideoModal from "../video/AddVideoModal";
import PracticeDocumentList from "../practiceDocument/PracticeDocumentList";
import AddPracticeDocumentModal from "../practiceDocument/AddPracticeDocumentModal";

const MarketingDetails = () => {
  const [selectedTab, setSelectedTab] = useState<any>(1);
  const clickTab = (tabIndex: React.SetStateAction<number>) => {
    setSelectedTab(tabIndex);
  };

  // Advertisement States
  const advertisementRef: any = useRef(null);
  const [allAdvertisements, setAllAdvertisements] = useState([]);
  const [singleAdvertisement, setAdvertisement] = useState("");
  const [isAdvertisementModalOpen, openAdvertisementModal] = useState(false);

  const getAllAdvertisements = () => {
    advertisementRef?.current?.MarketResear();
  };
  const addAdvertisement = (data?: any) => {
    setAdvertisement(data);
    openAdvertisementModal(true);
  };
  const closeAdvertisementModal = () => {
    openAdvertisementModal(false);
  };

  // New Release states
  const [singleMarketResearch, setMarketResearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const MarketResearchref: any = useRef(null);
  const [allData, setAllData] = useState([]);
  const addMarketResearch = (data?: any) => {
    setMarketResearch(data);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getDataALLs = () => {
    MarketResearchref?.current?.getDataALL();
  };

  // Video states
  const videoListRef = useRef<any>(null);
  const [allVideoData, setAllVideoData] = useState([]);
  const [singleVideo, setSingleVideo] = useState("");
  const [isVideoModalOpen, setVideoModalOpen] = useState(false);
  const addVideoModal = (data?: any) => {
    setSingleVideo(data);
    setVideoModalOpen(true);
  };
  const closeVideoModal = () => {
    setVideoModalOpen(false);
    getDataAllVideos();
  };
  const getDataAllVideos = () => {
    videoListRef.current.getDataALL();
  };

  // Practice Document states
  const practiceDocumentRef: any = useRef(null);
  const [allPracticeDocs, setAllPracticeDocs] = useState([]);
  const [singlePracticeDoc, setSinglePracticeDoc] = useState("");
  const [isPracticeDocModalOpen, setPracticeDocModalOpen] = useState(false);
  const addPracticeDocument = (data?: any) => {
    setSinglePracticeDoc(data);
    setPracticeDocModalOpen(true);
  };
  const closePracticeDocumentModal = () => {
    setPracticeDocModalOpen(false);
    getDataAllPracticeDocs();
  };
  const getDataAllPracticeDocs = () => {
    practiceDocumentRef.current.getDataALL();
  };

  return (
    <>
      <div className="rightside">
        <div className="allscreen">
          <div className="loadlisting">
            <div className="loads-head-card">
              <div className="flex-gap">
                <img src="assets/img/business-book.svg" alt="" />
                <div className="load-dispatched">
                  <h6 className="dispatched-title"> Marketing </h6>
                </div>
              </div>
              <div className="loadsheadcard">
                {selectedTab === 1 && (
                  <AddButton label="Add Advertisement" onClick={addAdvertisement} />
                )}
                {selectedTab === 2 && (
                  <AddButton label="Add New Release" onClick={addMarketResearch} />
                )}
                {selectedTab === 3 && (
                  <AddButton label="Add New Tutorials" onClick={addVideoModal} />
                )}
                {selectedTab === 4 && (
                  <AddButton label="Add Practice Document" onClick={addPracticeDocument} />
                )}
              </div>
            </div>

            <div className="loadlist">
              <div className="flex-between p-3">
                <div className="flex-gap">
                  <div className="loadbg">
                    <button
                      className={`px-2 py-[6px] text-sm lg:px-4 rounded-md font-medium shadow-sm ${
                        selectedTab === 1
                          ? "bg-greenBg text-white"
                          : "bg-customGray hover:bg-greenBg hover:text-white"
                      }`}
                      onClick={() => clickTab(1)}
                    >
                      Advertisements
                    </button>
                    <button
                      className={`px-2 py-[6px] text-sm lg:px-4 rounded-md font-medium shadow-sm ${
                        selectedTab === 2
                          ? "bg-greenBg text-white"
                          : "bg-customGray hover:bg-greenBg hover:text-white"
                      }`}
                      onClick={() => clickTab(2)}
                    >
                      New Release
                    </button>
                    <button
                      className={`px-2 py-[6px] text-sm lg:px-4 rounded-md font-medium shadow-sm ${
                        selectedTab === 3
                          ? "bg-greenBg text-white"
                          : "bg-customGray hover:bg-greenBg hover:text-white"
                      }`}
                      onClick={() => clickTab(3)}
                    >
                      Video Tutorials
                    </button>
                    <button
                      className={`px-2 py-[6px] text-sm lg:px-4 rounded-md font-medium shadow-sm ${
                        selectedTab === 4
                          ? "bg-greenBg text-white"
                          : "bg-customGray hover:bg-greenBg hover:text-white"
                      }`}
                      onClick={() => clickTab(4)}
                    >
                      Practice Documents
                    </button>
                  </div>
                </div>
              </div>

              {selectedTab === 1 && (
                <MarketResearchList
                  ref={advertisementRef}
                  allData={allAdvertisements}
                  setAllData={setAllAdvertisements}
                />
              )}
              {selectedTab === 2 && (
                <MarketNewResearchList
                  ref={MarketResearchref}
                  allData={allData}
                  setAllData={setAllData}
                />
              )}
              {selectedTab === 3 && (
                <VideoList
                  addEditModalOpen={addVideoModal}
                  allData={allVideoData}
                  setAllData={setAllVideoData}
                  ref={videoListRef}
                />
              )}
              {selectedTab === 4 && (
                <PracticeDocumentList
                  addEditModalOpen={addPracticeDocument}
                  allData={allPracticeDocs}
                  setAllData={setAllPracticeDocs}
                  ref={practiceDocumentRef}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <AddMarketResearch
        isOpen={isAdvertisementModalOpen}
        openModal={singleAdvertisement}
        closeModal={closeAdvertisementModal}
        getDataALLs={getAllAdvertisements}
      />
      <AddMarketNewRelease
        isOpen={isModalOpen}
        openModal={singleMarketResearch}
        closeModal={closeModal}
        getDataALLs={getDataALLs}
      />
      <AddVideoModal
        isOpen={isVideoModalOpen}
        openModal={singleVideo}
        closeModal={closeVideoModal}
        getDataALLs={getDataAllVideos}
      />
      <AddPracticeDocumentModal
        isOpen={isPracticeDocModalOpen}
        openModal={singlePracticeDoc}
        closeModal={closePracticeDocumentModal}
        getDataALLs={getDataAllPracticeDocs}
      />
    </>
  );
};

export default MarketingDetails;
